export default defineNuxtRouteMiddleware((to, from) => {
    if (import.meta.server) return
    if (to.path.match(/^\/speakers\/[^/]+$/)) {
        return navigateTo({ 
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, drawer: to.path }
        })
    }
    if (to.path.match(/^\/reservations\/[^/]+$/)) {
        return navigateTo({ 
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: to.path }
        })
    }    
    if (to.path.match(/^\/login\/?$/)) {
        return navigateTo({ 
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: to.path }
        })
    }
    if (to.path.match(/^\/search/)) {
        return navigateTo({ 
            path: from.fullPath,
            hash: from.hash,
            query: { ...from.query, ...to.query, modal: to.path }
        })
    }    
})